import React from 'react';
import { Upload, Trash2, RefreshCw } from 'lucide-react';
import { Section, ImageField } from './FormFields';

const ImagesTab = ({
  content,
  images,
  updateSimpleField,
  uploadAndGetUrl,
  handleDrag,
  handleDrop,
  handleFileSelect,
  deleteImage,
  copyImageUrl,
  uploading,
  dragActive
}) => {
  return (
    <div className="space-y-6">
      <Section title="Site Images" description="Manage all images used across the website.">
        <ImageField 
          label="Logo" 
          value={content.images?.logo || ''} 
          onChange={(v) => updateSimpleField('images', 'logo', v)} 
          onUpload={uploadAndGetUrl} 
        />
        <ImageField 
          label="Header Symbol (Small Logo)" 
          value={content.images?.headerSymbol || ''} 
          onChange={(v) => updateSimpleField('images', 'headerSymbol', v)} 
          onUpload={uploadAndGetUrl} 
          description="Optional: Small symbol-only logo for header" 
        />
        <ImageField 
          label="Hero Image" 
          value={content.images?.heroImage || ''} 
          onChange={(v) => updateSimpleField('images', 'heroImage', v)} 
          onUpload={uploadAndGetUrl} 
        />
        <ImageField 
          label="Story Image" 
          value={content.images?.storyImage || ''} 
          onChange={(v) => updateSimpleField('images', 'storyImage', v)} 
          onUpload={uploadAndGetUrl} 
        />
      </Section>

      <Section title="Upload New Images" description="Upload images to use anywhere on the site.">
        <div 
          onDragEnter={handleDrag} 
          onDragLeave={handleDrag} 
          onDragOver={handleDrag} 
          onDrop={handleDrop}
          className={`border-2 border-dashed rounded-xl p-8 text-center transition-colors ${dragActive ? 'border-slate-900 bg-slate-50' : 'border-slate-300'}`}
        >
          <Upload className="w-12 h-12 text-slate-400 mx-auto mb-4" />
          <p className="text-lg font-medium text-slate-700 mb-2">Drag and drop images here</p>
          <label className="inline-flex items-center gap-2 bg-slate-900 text-white px-6 py-2 rounded-lg font-medium hover:bg-slate-800 cursor-pointer">
            <Upload className="w-4 h-4" /> Browse Files
            <input type="file" accept="image/*" onChange={handleFileSelect} className="hidden" />
          </label>
          {uploading && (
            <div className="mt-4 flex items-center justify-center gap-2 text-slate-600">
              <RefreshCw className="w-4 h-4 animate-spin" /> Uploading...
            </div>
          )}
        </div>
      </Section>

      {images.length > 0 && (
        <Section title="Image Library" description="Click to copy URL, or delete unused images.">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {images.map((image) => (
              <div key={image.filename} className="bg-slate-50 rounded-lg overflow-hidden group">
                <div className="aspect-square relative">
                  <img src={image.url} alt={image.filename} className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2">
                    <button onClick={() => copyImageUrl(image.url)} className="p-2 bg-white rounded-lg hover:bg-slate-100 text-xs">Copy URL</button>
                    <button onClick={() => deleteImage(image.filename)} className="p-2 bg-red-600 text-white rounded-lg hover:bg-red-700">
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                </div>
                <div className="p-2">
                  <p className="text-xs text-slate-500 truncate">{image.filename}</p>
                </div>
              </div>
            ))}
          </div>
        </Section>
      )}
    </div>
  );
};

export default ImagesTab;
